/*
 * @Author: NIXY
 * @LastEditors: gongwy gongwy@yinhai.com
 * @Date: 2022-09-06 09:51:48
 * @LastEditTime: 2023-01-28 09:37:03
 * @Description: desc
 * @FilePath: \dld-vue-mobile\src\router\index.js
 */
import Vue from 'vue';
import Router from 'vue-router';
import { Indicator, MessageBox } from 'mint-ui';
Vue.use(Router);

const _routes = [
  {
    path: '/',
    name: 'index',
    redirect: 'home',
    component: (resolve) => require(['@/pages/index'], resolve),
    children: [
      // 之前的首页，只是做一个导航页面使用
      {
        path: "homeold",
        name: "homeold",
        component: (resolve) => require(["@/pages/home"], resolve),
      },
      // 新主页
      {
        path: 'home',
        name: 'home',
        component: (resolve) => require(['@/pages/home/index'], resolve)
      },
      // 事件详情
      {
        path: 'eventdetail',
        name: 'eventdetail',
        component: (resolve) => require(['@/pages/event/eventdetail.vue'], resolve)
      },
      //  运行态势  达州名片
      {
        path: 'runningSituation',
        name: 'runningSituation',
        component: (resolve) => require(['@/pages/runningSituation/longList.vue'], resolve)
      },
      //  运行态势  echarts地图
      {
        path: 'dzmap',
        name: 'dzmap',
        component: (resolve) => require(['@/pages/runningSituation/part/dz-map.vue'], resolve)
      },
      // 事件大屏  长列表页面   达州之事
      {
        path: 'eventChart',
        name: 'eventChart',
        component: (resolve) => require(['@/pages/event/eventHandle.vue'], resolve)
      },
      // 达州之事  事件列表的长列表页面
      {
        path: 'eventlist',
        name: 'eventlist',
        component: (resolve) => require(['@/pages/event/part/event-list.vue'], resolve)
      },
      // 云上经济-产业发展
      {
        path: 'economicChart',
        name: 'economicChart',
        component: (resolve) => require(['@/pages/economic/economicOperationNew.vue'], resolve)
      },
      // 民生直达-居民收支
      {
        path: 'livelihoodDirect',
        name: 'livelihoodDirect',
        component: (resolve) => require(['@/pages/livelihoodDirect/index.vue'], resolve)
      },
      // 云上经济-产业发展-企业详情
      {
        path: 'companyDetail',
        name: 'companyDetail',
        component:resolve =>require(["@/pages/economic/companyDetail.vue"],resolve),
      },
      // 今日达州
      {
        path: 'todaydz',
        name: 'todaydz',
        component:resolve =>require(["@/pages/today-dz/todaydz"],resolve),
      },
      // 达州之事  事件列表的长列表页面
      {
        path: 'perceptionlist',
        name: 'perceptionlist',
        component: (resolve) => require(['@/pages/event/part/perceptionlist.vue'], resolve)
      },
      {
        path: 'map',
        name: 'map',
        component: (resolve) => require(['@/pages/map/map.vue'], resolve)
      },
      



      // 民生保障地图
      {
        path: 'livelihoodGuarantee',
        name: 'livelihoodGuarantee',
        component: (resolve) => require(['@/pages/livelihoodGuarantee'], resolve)
      },
      // 民生保障 长列表
      {
        path: 'society-ensure',
        name: 'society-ensure',
        component: (resolve) => require(['@/pages/livelihoodGuarantee/society-ensure'], resolve)
      },
      {
        path: 'business-map',
        name: 'business-map',
        component: (resolve) => require(['@/pages/business-map'], resolve)
      },
      {
        // 营商环境
        path: 'businessEnvironment',
        name: 'businessEnvironment',
        component: (resolve) => require(['@/pages/businessEnvironment'], resolve)
      },
      {
        path: 'business',
        name: 'business',
        component: (resolve) => require(['@/pages/business-map/business'], resolve)
      },

      // 疫情防控地图页面
      {
        path: 'epidemic',
        name: 'epidemic',
        component: (resolve) => require(['@/pages/epidemic/index.vue'], resolve)
      },
      // 疫情防控地图 => 信息详情页面
      {
        path: 'epidemic/prevention',
        name: 'prevention',
        component: (resolve) => require(['@/pages/epidemic/epidemicPrevention.vue'], resolve)
      },
      // 疫情防控 长列表页面
      {
        path: 'epidemic/chart',
        name: 'epidemicChart',
        component: (resolve) => require(['@/pages/epidemic/epidemic04.vue'], resolve)
      },
      {
        path: 'epidemic/traceability',
        name: 'traceability',
        component: (resolve) => require(['@/pages/epidemic/positiveTraceability.vue'], resolve)
      },
      {
        path: 'epidemic/routeMap',
        name: 'routeMap',
        component: (resolve) => require(['@/pages/epidemic/routeMap.vue'], resolve)
      },
      // 事件大屏 地图页面
      {
        path: 'eventhandle',
        name: 'eventhandle',
        component: (resolve) => require(['@/pages/event/index.vue'], resolve)
      },

      
      {
        path: 'economic',
        name: 'economic',
        component: (resolve) => require(['@/pages/economic/index.vue'], resolve)
      },
      // {
      //   path: 'economicChart',
      //   name: 'economicChart',
      //   component:resolve =>require(["@/pages/economic/economicOperation.vue"],resolve),
      // },


      {
        path: 'projectSupervision',
        name: 'projectSupervision',
        component: (resolve) => require(['@/pages/projectSupervision/index.vue'], resolve)
      },
      {
        path: 'projectSupervision/projectChart',
        name: 'projectChart',
        component: (resolve) => require(['@/pages/projectSupervision/projectSupervision.vue'], resolve)
      },
      {
        path: 'projectSupervision/projectMessage',
        name: 'projectMessage',
        component: (resolve) => require(['@/components/major-project/major-project-message.vue'], resolve)
      },

      {
        path: 'cityPerception',
        name: 'cityPerception',
        component: (resolve) => require(['@/pages/cityPerception/index.vue'], resolve)
      },
      // {
      //   path: "cityPerception/cityPartChart",
      //   name: "cityPartChart",
      //   component: (resolve) =>
      //     require(["@/pages/cityPerception/cityPerception.vue"], resolve),
      // },
      {
        path: 'cityPerception/cityPartChart',
        name: 'cityPartChart',
        component: (resolve) => require(['@/pages/cityPerception/cityPerceptionNew.vue'], resolve)
      },
      // 数字底座
      {
        path: 'digitalBase',
        name: 'digitalBase',
        component: resolve => require(["@/pages/digitalBase/index.vue"], resolve),
      },
    ]
  },
  {
    path: 'major-project-detail',
    component: (resolve) => require(['@/pages/index'], resolve),
    children: [
      {
        path: 'detail',
        name: 'major-project-detail',
        component: (resolve) => require(['@/components/major-project/major-project-message.vue'], resolve)
      }
    ]
  }
];
let routes = _routes;
//   .concat(mineRoutes)

const router = new Router({
  routes
  // mode: 'history',
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js